<template>
  <div>
    <svg class="g-icon bbbbbbb">
      <use :xlink:href="`#i-${name}`" />
    </svg>
  </div>
</template>

<script>
import './svg'
export default {
    props:['name']
};
</script>

<style lang="scss" scoped>
        .g-icon {
            width: 1em;
            height: 1em;
            vertical-align: -0.15em;
            fill: currentColor;
            overflow: hidden;
        }
</style>